export default __webpack_public_path__ + "img/6099db8cd4aac50fdea562f0c85e1e06.png";